module.exports = __webpack_public_path__ + "static/media/EnrichBadOptimized.1f40f8b4.png";